// SaboresHub — página con dos pestañas: Típicos (Flavors) + Restaurantes.
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Flavors from "./Flavors";
import Restaurants from "./Restaurants";

export default function SaboresHub() {
  // Lee ?tab=restaurantes para abrir directo, o /restaurantes en la ruta
  const location = useLocation();
  const paramTab = new URLSearchParams(location.search).get("tab");
  const initial = paramTab === "restaurantes" || location.pathname.endsWith("/restaurantes")
    ? "restaurantes"
    : "tipicos";
  const [tab, setTab] = useState(initial);

  return (
    <div data-testid="sabores-hub">
      {/* Tabs sticky bajo el notch */}
      <div className="sticky top-0 z-40 backdrop-blur-md bg-[hsl(var(--bg))]/85 border-b border-[hsl(var(--line))]">
        <div className="container-app flex gap-2 py-3">
          <button
            onClick={() => setTab("tipicos")}
            className={`flex-1 py-2 rounded-xl text-sm font-semibold transition-all ${
              tab === "tipicos"
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--bg))]"
                : "bg-[hsl(var(--bg-card))] text-[hsl(var(--ink-soft))] border border-[hsl(var(--line))]"
            }`}
            data-testid="sabores-tab-tipicos"
          >
            🍰 Típicos
          </button>
          <button
            onClick={() => setTab("restaurantes")}
            className={`flex-1 py-2 rounded-xl text-sm font-semibold transition-all ${
              tab === "restaurantes"
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--bg))]"
                : "bg-[hsl(var(--bg-card))] text-[hsl(var(--ink-soft))] border border-[hsl(var(--line))]"
            }`}
            data-testid="sabores-tab-restaurantes"
          >
            🍽️ Restaurantes
          </button>
        </div>
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={tab}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {tab === "tipicos" ? <Flavors hideBackLink /> : <Restaurants hideBackLink />}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
